import { create } from 'zustand';

interface ActivacionState {
  canChangeNap: boolean;
  canChangeNodeOLT: boolean;

  setCanChangeNap: (value: boolean) => void;
  setCanChangeNodeOLT: (value: boolean) => void;
}

export const useActivacionStore = create<ActivacionState>(set => ({
  canChangeNap: false,
  canChangeNodeOLT: false,

  setCanChangeNap: value => set({ canChangeNap: value }),
  setCanChangeNodeOLT: value => set({ canChangeNodeOLT: value }),
}));
